const $ = window.$; // global jquery has slick slider

const carCard = {
  init: function() {
    const self = this;
    const carCard = document.getElementById('car-card');

    if (typeof carCard !== 'undefined' && carCard !== null) {
      const blurpWarrantyLink = document.getElementById('warranty-read-more-link');

      if (typeof blurpWarrantyLink !== 'undefined' && blurpWarrantyLink !== null) {
        document.querySelector('.special-car-info > ul > li:last-child').appendChild(blurpWarrantyLink);
      }

      //Information tab menu
      const tabButtons = carCard.querySelectorAll('#car-info-tab-menu > .tab-container button'),
        infoCollasibles = carCard.querySelectorAll('.car-info-collasible');

      for (let i = 0; i < tabButtons.length; i++) {
        tabButtons[i].addEventListener('click', function(event) {
          self._toggleCollasible(tabButtons, infoCollasibles, event.target);

          //Scroll to correct position (anchor) on mobile
          if (window.innerWidth <= 1024 && event.target.classList.contains('active')) {
            carCard.parentElement.querySelector('a[data-anchor-id="' + event.target.dataset.target + '"]').scrollIntoView();
          }
        });
      }

      //open large screen
      if(window.innerWidth > 1075) {
        const details = carCard.parentElement.querySelectorAll('.header-list__container details')
        details.forEach(item => item.open = true)
      }

      //Switch from horizontal tabs to vertical collasibles on mobile, and vice versa
      this._setupCollasibles([infoCollasibles]);

      window.addEventListener('resize', function (event) {
        self._setupCollasibles([infoCollasibles]);
      });

      $('#car-card-list').slick('slickSetOption', {
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
              arrows: true,
            }
          },{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
              arrows: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
            }
          }
        ]
      }, true);
    }
  },

  _toggleCollasible: function(tabButtons, collasibles, target) {
    for (let i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i] === target && !(tabButtons[i].classList.contains('active'))) {
        tabButtons[i].classList.add('active');
      } else {
        tabButtons[i].classList.remove('active');
      }
    }

    for (let i = 0; i < collasibles.length; i++) {
      if (collasibles[i].dataset.collasibleId === target.dataset.target && !(collasibles[i].classList.contains('show'))) {
        collasibles[i].classList.add('show');
      }
      else {
        collasibles[i].classList.remove('show');
      }
    }
  },

  _setupCollasibles: function(collasiblesArray) {
    for (let j = 0; j < collasiblesArray.length; j++) {
      for (let k = 0; k < collasiblesArray[j].length; k++) {
        if (window.innerWidth <= 1024) {
          const targetCollasible = document.querySelector('[data-target="' + collasiblesArray[j][k].dataset.collasibleId + '"]');

          if (!targetCollasible) {
            continue;
          }

          if (!targetCollasible.parentElement.contains(collasiblesArray[j][k])) {
            targetCollasible.parentElement.appendChild(collasiblesArray[j][k]);
          }
        }
        else {
          const collasibleContainer = document.querySelector('[data-container-id="' + collasiblesArray[j][k].dataset.collasibleId + '"]');

          if (!collasibleContainer.contains(collasiblesArray[j][k])) {
            collasibleContainer.appendChild(collasiblesArray[j][k]);
          }
        }
      }
    }
  }
};

export default carCard;
